import { useEffect, type RefObject } from "react";

/** Esc + click-outside collapse for the expanded Firefly panel. */
export function useActivityDockPanelDismiss(
  ref: RefObject<HTMLDivElement | null>,
  onClose: () => void,
) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    function onMouse(e: MouseEvent) {
      if (!ref.current) return;
      const target = e.target as Node | null;
      if (target && ref.current.contains(target)) return;
      // Ignore mousedowns on the Firefly tab — it owns the open/close toggle.
      if (target instanceof Element && target.closest("[data-activity-dock-tab]")) {
        return;
      }
      onClose();
    }
    const id = window.setTimeout(() => document.addEventListener("mousedown", onMouse), 50);
    return () => {
      window.clearTimeout(id);
      document.removeEventListener("mousedown", onMouse);
    };
  }, [onClose, ref]);
}
